export enum PaymentStatus {
  NotExpired,
  FirstDueDateExpired,
  SecondDueDateExpired
}

